import { Form, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";
import { PrivateKistForm } from "./sectionKist.privateKist.form.jsx";

export const PrivateKistModal = ({
  visible,
  kist_id,
  registratie,
  type,
  callsign,
  flarm,
  category,
  start_methode,
  closeModal,
  saveFlight,
}) => {
  if (!visible) return null;
  
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(false);
    return () => setLoading(false);
  }, [visible]);

  useEffect(() => {
    form.setFieldsValue({
      registratie,
      type,
      callsign,
      flarm,
    });
  }, [registratie, type, callsign, flarm]);

  return (
    <Modal
      title={kist_id ? $t("Wijzig privé kist") : $t("Voeg privé kist toe")}
      open={visible}
      confirmLoading={loading}
      onCancel={() => {
        form.resetFields();
        closeModal();
      }}
      okText={$t("Opslaan")}
      cancelText={$t("Annuleren")}
      onOk={async () => {
        try {
          const values = await form.validateFields();
          setLoading(true);
          await saveFlight({
            add_kist: 1,
            ...values,
          });
          closeModal(true);
          setLoading(false);
          form.resetFields();
        } catch (info) {
          console.log("Validate Failed:", info);
          setLoading(false);
        }
      }}
    >
      <PrivateKistForm
        form={form}
        layout="horizontal"
        initialValues={{
          registratie,
          type,
          callsign,
          flarm,
          category,
          start_methode
        }}
      />
    </Modal>
  );
};
